import cx               from 'classnames';
import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';
import Link             from 'next/link';

const UnitellerPage = (props) => {
    let pageCSS = cx({
        page: true,
        defaultPage: true,
        Definitions: true
    });

    const pageHeadStyle = {
        backgroundImage: 'url("/static/img/index-business/img_business@2x.png")'
    };

    return (
        <Layout {...props}>
            <div className={pageCSS}>
                <div className="default-head" style={pageHeadStyle}>
                    <div className="container">
                        <h1 className="default-header">Правила оплаты и безопасность платежей, конфиденциальность информации</h1>
                    </div>
                </div>
                <div className="default-cnt">
                    <div className="container">
                        <div className="max-width">
                            <p>К оплате принимаются карты VISA, MasterCard, МИР.</p>

                            <p>Уважаемый клиент!
                                Вы можете оплатить свой заказ онлайн с помощью предложенных методов оплат через платежный сервис компании Uniteller. После подтверждения заказа Вы будете перенаправлены на защищенную платежную страницу Uniteller, где необходимо будет ввести данные для оплаты заказа. После успешной оплаты на указанную в форме оплаты электронную почту будет направлен электронный чек с информацией о заказе и данными по произведенной оплате.
                                Гарантии безопасности
                                Безопасность процессинга uniteller подтверждена сертификатом стандарта безопасности данных индустрии платежных карт PCI DSS. Надежность сервиса обеспечивается интеллектуальной системой мониторинга мошеннических операций, а также применением 3D Secure - современной технологией безопасности интернет-платежей.
                                Данные Вашей карты вводятся на специальной защищенной платежной странице. Передача информации в процессинговую компанию Uniteller происходит с применением технологии шифрования TLS. Дальнейшая передача информации осуществляется по закрытым банковским каналам, имеющим наивысший уровень надежности.
                                Uniteller не передает данные Вашей карты магазину и иным третьим лицам!
                                Если Ваша карта поддерживает технологию 3D Secure, для осуществления платежа, Вам необходимо будет пройти дополнительную проверку пользователя в банке-эмитенте (банк, который выпустил Вашу карту). Для этого Вы будете направлены на страницу банка, выдавшего карту. Вид проверки зависит от банка. Как правило, это дополнительный пароль, который отправляется в SMS, карта переменных кодов, либо другие способы.
                                Если у Вас возникли вопросы по совершенному платежу, Вы можете обратиться в службу технической поддержки процессингового центра Uniteller: support@uniteller.ru или по телефону 8 800 707 67 19.</p>



                            <h3>Правила возврата денежных средств</h3>
                            <p>
                                В случае если Пользователь произвел оплату услуг и отказался от Заказа по собственной инициативе и уведомил об этом Администрацию не менее чем за 3 (Три) часа до оказания услуги, Администрация осуществляет возврат денежных средств Пользователю. Процедура возврата регламентируется статьей 26.1 федерального закона «О защите прав потребителей».
                                Возвратный платеж осуществляется в размере стоимости оплаченных услуг, за вычетом фактически понесенных расходов (в соответствии со статьей 32 Федерального закона РФ «О защите прав потребителей в РФ» и части 1 статьи 782 Гражданского кодекса РФ), на счет Пользователя в соответствии с выбранным способом оплаты в течение 20 (Двадцати) банковских дней с момента оформления возврата.
                                В случае если Пользователь не воспользовался услугами, возврат денежных средств за неиспользованные услуги аренды транспортного средства с экипажем не производится.  Для возврата денежных средств на банковскую карту необходимо заполнить «Заявление о возврате денежных средств», которое высылается по требованию компанией на электронный адрес и оправить его вместе с приложением копии паспорта по адресу info@mover24.ru или обратиться в службу поддержки MOVER.
                                Возврат денежных средств будет осуществлен на банковскую карту в течение 21 (двадцати одного) рабочего дня со дня получения «Заявление о возврате денежных средств» Компанией.
                                Для возврата денежных средств по операциям проведенными с ошибками необходимо обратиться с письменным заявлением и приложением копии паспорта и чеков/квитанций, подтверждающих ошибочное списание. Данное заявление необходимо направить по адресу info@mover24.ru
                                Сумма возврата будет равняться сумме покупки. Срок рассмотрения Заявления и возврата денежных средств начинает исчисляться с момента получения Компанией Заявления и рассчитывается в рабочих днях без учета праздников/выходных дней.
                            </p>

                            <h3>Контактная информация</h3>
                            <p>
                                Название компании ООО "8PX "<br />
                                ИНН / КПП	7722451767/772201001<br />
                                ОГРН	1187746412776<br />
                                Фактический адрес	"127137, г.Москва, ул. Правды, д.24, стр.3"
                                Телефон	8-916-526-47-13<br />
                                Факс	8-916-526-47-13<br />
                                E-mail:	info@mover24.ru<br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

UnitellerPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});

    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: 'opacity',
        curLang,
        pathname,
        title: 'MOVER: Uniteller партнер по приему платежей',
        description: 'Правила оплаты и безопасность платежей, конфиденциальность информации'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(UnitellerPage);



